import * as React from 'react';
import SelectInput from './SelectInput';
import { segments, roles, regions } from './formData';
import { ProfileSelect } from '../../../../store/action/profileActions';
import { REGION, ROLE, SEGMENT } from '../../../../store/constants';
import Section from '../../Section';

interface Props {
    profileOptionSelect: ProfileSelect;
    segment: string;
    role: string;
    region: string;
}

class ProfileContent extends React.Component<Props> {
    render() {
        const {
            profileOptionSelect,
            segment,
            role,
            region
        } = this.props;

        return (
            <Section>
                <form>
                    <SelectInput
                        id={SEGMENT}
                        label="Industry Segment"
                        selection={segment}
                        options={segments}
                        onSelect={profileOptionSelect}
                    />
                    <SelectInput
                        id={ROLE}
                        label="Role"
                        selection={role}
                        options={roles}
                        onSelect={profileOptionSelect}
                    />
                    <SelectInput
                        id={REGION}
                        label="Region"
                        selection={region}
                        options={regions}
                        onSelect={profileOptionSelect}
                    />
                </form>
            </Section>
        );
    }
}

export default ProfileContent;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/profile/ProfileContent.tsx